import { render, staticRenderFns } from "./invertization.vue?vue&type=template&id=4f60b264&scoped=true"
import script from "./invertization.vue?vue&type=script&lang=js"
export * from "./invertization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f60b264",
  null
  
)

export default component.exports